// import request from '@/utils/request'
import config from "@/config";
import http from "@/utils/request";
export default {
	sellProduct: {
		url: `${config.API_URL}/sell_products/show/all`,
		name: "获取全部销售产品",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	sellProductSelf: {
		url: `${config.API_URL}/sell_products/self/show/all`,
		name: "获取自身销售产品",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	expressCategory: {
		url: `${config.API_URL}/service_types/show/all/`,
		name: "快递类别",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	country: {
		url: `${config.API_URL}/countrys`,
		name: "获取家",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	sendAddress: {
		url: `${config.API_URL}/send_addresses/self`,
		name: "获取当前客户的发件地址",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	receiveAddress: {
		url: `${config.API_URL}/receive_addresses/self`,
		name: "获取当前客户的收件地址",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	importerAddress: {
		url: `${config.API_URL}/importer_addresses/self`,
		name: "获取当前客户的进口商地址",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	currencyType: {
		url: `${config.API_URL}/currencys`,
		name: "获取货币单位",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	termsOfSale: {
		url: `${config.API_URL}/terms_ofsale`,
		name: "获取销售条款",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getProvince: {
		url: `${config.API_URL}/provinces/country/`,
		name: "根据国家获取省州",
		get: async function (data) {
			this.url = `${config.API_URL}/provinces/country/` + data;
			return await http.get(this.url, null);
		},
	},
	getCity: {
		url: `${config.API_URL}/citys/province/`,
		name: "根据省州获取城市",
		get: async function (data) {
			this.url = `${config.API_URL}/citys/province/` + data;
			return await http.get(this.url, null);
		},
	},
	getCounty: {
		url: `${config.API_URL}/countys/city/`,
		name: "根据城市获取区县",
		get: async function (data) {
			this.url = `${config.API_URL}/countys/city/` + data;
			return await http.get(this.url, null);
		},
	},
	getUnit: {
		url: `${config.API_URL}/entrys_unit`,
		name: "单位",
		get: async function (param) {
			return await http.get(this.url, param);
		},
	},
	getPlatformErpTypes: {
		url: `${config.API_URL}/platform_erp_types`,
		name: "电商ERP类型",
		get: async function (param) {
			return await http.get(this.url, param);
		},
	},
	transportFundTypes: {
		url: `${config.API_URL}/transport_fund_types/`,
		name: "运单费用类型",
		get: async function () {
			return await http.get(this.url);
		},
	},
	companyCard: {
		url: `${config.API_URL}/company_cards/`,
		name: "收款账号",
		get: async function () {
			return await http.get(this.url);
		},
	},
	getUserSelf: {
		url: `${config.API_URL}/users/self`,
		name: "获取当前用户",
		get: async function () {
			return await http.get(this.url);
		},
	},
	getUserAccounts: {
		url: `${config.API_URL}/user_accounts/user/self`,
		name: "获取当前用户账户详情",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getAnnouncement: {
		url: `${config.API_URL}/message_notices_send/user/desc/search/of/page`,
		name: "获取公告",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	entryDescription: {
		url: `${config.API_URL}/entrys_description/self/of/show/all/`,
		name: "报关商品配置",
		get: async function () {
			return await http.get(this.url);
		},
	},
	fbaCountry: {
		url: `${config.API_URL}/fbas/country/`,
		name: "根据国家获取fba仓库",
		get: async function (params) {
			this.url = `${config.API_URL}/fbas/country/` + params;
			return await http.get(this.url);
		},
	},
	getUserInfo: {
		url: `${config.API_URL}/user_infos/self`,
		name: "获取当前用户详情",
		get: async function () {
			return await http.get(this.url);
		},
	},
	updateUserInfo: {
		url: `${config.API_URL}/user_infos/self`,
		name: "修改当前用户详情",
		put: async function (data) {
			return await http.put(this.url, data);
		},
	},
	updatePassword: {
		url: `${config.API_URL}/change_password`,
		name: "修改当前用户密码",
		post: async function (data) {
			return await http.post(this.url, data);
		},
	},
	getPostcode: {
		url: `${config.API_URL}/postcode_addresses_match/like/search/get`,
		name: "根据城市获取邮编",
		get: async function (data) {
			return await http.get(this.url, data);
		},
	},
	getRemote: {
		url: `${config.API_URL}/remotes/search/all`,
		name: "下单时查询是否偏远",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getSystemBaseConfig: {
		url: `${config.API_URL}/system_base_configs/search/all`,
		name: "获取客户默认配置",
		get: async function () {
			return await http.get(this.url);
		},
	},
	searchLine: {
		url: `${config.API_URL}/line_assign_accounts/desc/search/line/`,
		name: "查询选中销售产品的线路",
		get: async function (data) {
			this.url = `${config.API_URL}/line_assign_accounts/desc/search/line/${data.line}?is_default=1`;
			return await http.get(this.url);
		},
	},
	getRequired: {
		url: `${config.API_URL}/assign_configs/search/all`,
		name: "查询下单必填项",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
};
// // 销售产品
// export function sellProduct() {
// 	return request.get(
// 	  '/sell_products/self/show/all'
// 	)
// }
// export function sellProduct() {
// 	return request.get(
// 	  '/sell_products/self/show/all',
//     null,
//     config
// 	)
// }
// 国家
// export function country() {
// 	return request.get(
// 	  '/countrys',
//     null
// 	)
// }
// // 当前客户的发件地址
// export function sendAddress() {
// 	return request.get(
// 	  '/send_addresses/self',
//     null
// 	)
// }
// // 当前客户的发件地址
// export function receiveAddress() {
// 	return request.get(
// 	  '/receive_addresses/self',
//     null
// 	)
// }
// // 货币单位
// export function currencyType() {
// 	return request.get(
// 	  '/currencys',
//     null
// 	)
// }
// // 销售条款
// export function termsOfSale() {
// 	return request.get(
// 	  '/terms_ofsale',
//     null
// 	)
// }
// // 根据国家获取省州
// export function getProvince(data) {
// 	return request.get(
// 	  '/provinces/country/' + data,
//     null
// 	)
// }
// // 根据国家获取省州
// export function getCity(data) {
// 	return request.get(
// 	  '/citys/province/' + data,
//     null
// 	)
// }
// // 根据国家获取省州
// export function getCounty(data) {
// 	return request.get(
// 	  '/countys/city/' + data,
//     null
// 	)
// }
// // 单位
// export function getUnit() {
// 	return request.get(
// 	  '/entrys_unit',
//     null
// 	)
// }
